import { apiWithOffline } from './api';
import localDB from './localDB';
import {
  buildFinancePeriods,
  buildFinanceStats,
  getPeriodRange,
} from '../utils/financeReports';

async function localReportRows(group) {
  const [tasks, finances] = await Promise.all([
    localDB.getTasks().catch(() => []),
    localDB.getFinances().catch(() => []),
  ]);
  return buildFinancePeriods(finances, tasks, group);
}

export const financesService = {
  getReportsStats: async () => {
    try {
      const response = await apiWithOffline.get('/finances/reports-stats');
      return response.data || {};
    } catch (error) {
      const [tasks, finances] = await Promise.all([
        localDB.getTasks().catch(() => []),
        localDB.getFinances().catch(() => []),
      ]);
      return buildFinanceStats(finances, tasks);
    }
  },

  getByMonth: async (params = {}) => {
    const group = params.group || 'month';
    try {
      const response = await apiWithOffline.get('/finances/by-month', {
        params: { group },
      });
      const rows = Array.isArray(response?.data) ? response.data : [];

      if (rows.length > 0 && rows[0]?.period == null) {
        return localReportRows(group);
      }

      return rows;
    } catch (error) {
      if (
        error.message?.includes('offline')
        || error.message?.includes('No data')
      ) {
        return localReportRows(group);
      }
      throw error;
    }
  },

  getPeriodEntries: async (period, group = 'month') => {
    const range = getPeriodRange(period, group);
    if (!range.start_date || !range.end_date) return [];

    const response = await apiWithOffline.get('/finances', { params: range });
    const rows = Array.isArray(response?.data) ? response.data : [];
    return rows
      .filter((finance) => finance && ['income', 'expense'].includes(finance.type))
      .sort((a, b) => String(b.date || '').localeCompare(String(a.date || '')));
  },
};
